import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DataTablePage from 'components/DataTablePage';
import leaderboardScoresColumnData from 'data/leaderboardScoresColumnData';
import { getLeaderboard, getLeaderboardScores } from 'services/game-leaderboards';

function LeaderboardDetails() {
  const { id } = useParams();
  const [leaderboard, setLeaderboard] = useState(null);

  useEffect(() => {
    getLeaderboard(id).then((res) => setLeaderboard(res?.data || res));
  }, [id]);

  const fetchScores = (limit, page) => getLeaderboardScores(id, limit, page);

  const title = leaderboard?.name ? `Leaderboard: ${leaderboard.name}` : 'Leaderboard';
  const period =
    leaderboard?.startAt && leaderboard?.endAt
      ? `${new Date(leaderboard.startAt).toLocaleString()} - ${new Date(leaderboard.endAt).toLocaleString()}`
      : '';

  return (
    <DataTablePage
      title={title}
      createButton={
        period ? (
          <MDBox textAlign='right'>
            <MDTypography variant='button' fontWeight='medium'>
              {period}
            </MDTypography>
          </MDBox>
        ) : null
      }
      canSearch
      fetchData={fetchScores}
      queryKey={`leaderboard-${id}-scores`}
      columnData={leaderboardScoresColumnData}
      object={'leaderboard-score'}
      noActions
    />
  );
}

export default LeaderboardDetails;
